export class InsuranceCompanyModel {
insid = 0 ;
insenglishname = '' ;
insarabicname = '' ;
insaddress = '' ;
insphone1 = '' ;
insphone2 = '' ;
insemail = '' ;
inscontatpersonname = '' ;
inscontatpersontitle = '' ;
inscontatpersonmobile = '' ;
inscontatpersonemail = '' ;
insapprovalsemail = '' ;
insstartdate = '2024-01-01' ;
insenddate = '2024-01-01'  ;
inslogo = '' ;
userid = '' ;
modifaieddate = '2024-01-01'  ;
compcode = '' ;
}